export const ListingTransactionHistoryProperty = {
  Tabs: 'tabs',
  ActiveListingId: 'activeListingId',
  Origin: 'origin',
};

export const ListingTransactionHistoryEventType = {
  TransactionChange: 'transactionChange',
};
